// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = "/auth";
const ROOTS_DASHBOARD = "/dashboard";

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, "/login"),
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  general: {
    app: path(ROOTS_DASHBOARD, "/app"),
    dashboard: path(ROOTS_DASHBOARD, "/app"),
  },
  students: {
    root: path(ROOTS_DASHBOARD, "/students"),
    list: path(ROOTS_DASHBOARD, "/students/list"),
    new: path(ROOTS_DASHBOARD, "/students/new"),
    view: path(ROOTS_DASHBOARD, "/students/view"),
    applications: path(ROOTS_DASHBOARD, "/students/applications"),
  },

  metadata: {
    root: path(ROOTS_DASHBOARD, "/metadata"),
    year: path(ROOTS_DASHBOARD, "/metadata/year"),
    grades: path(ROOTS_DASHBOARD, "/metadata/grades"),
    learningcentres: path(ROOTS_DASHBOARD, "/metadata/learningcentres"),
    departments: path(ROOTS_DASHBOARD, "/metadata/departments"),
  },

  staff: {
    root: path(ROOTS_DASHBOARD, "/staff"),
    new: path(ROOTS_DASHBOARD, "/staff/new"),
    list: path(ROOTS_DASHBOARD, "/staff/list"),
    attendance: path(ROOTS_DASHBOARD, "/staff/attendance"),
    temp: path(ROOTS_DASHBOARD, "/staff/temp"),
  },

  paces: {
    root: path(ROOTS_DASHBOARD, "/paces"),
    new: path(ROOTS_DASHBOARD, "/paces/new"),
    list: path(ROOTS_DASHBOARD, "/paces/list"),
    store: path(ROOTS_DASHBOARD, "/paces/store"),
    inventory: path(ROOTS_DASHBOARD, "/paces/inventory"),
  },

  parent: {
    root: path(ROOTS_DASHBOARD, "/parents"),
    new: path(ROOTS_DASHBOARD, "/parents/new"),
    list: path(ROOTS_DASHBOARD, "/parents/list"),
  },

  classlist: {
    root: path(ROOTS_DASHBOARD, "/classlist"),
    list: path(ROOTS_DASHBOARD, "/classlist/list"),
  },

  subjects: {
    root: path(ROOTS_DASHBOARD, "/subjects"),
    list: path(ROOTS_DASHBOARD, "/subjects/list"),
    other: path(ROOTS_DASHBOARD, "/subjects/other"),
  },

  projections: {
    root: path(ROOTS_DASHBOARD, "/projections"),
    list: path(ROOTS_DASHBOARD, "/projections/list"),
    orders: path(ROOTS_DASHBOARD, "/projections/paceorder"),
  },

  tracking: {
    root: path(ROOTS_DASHBOARD, "/tracking"),
    list: path(ROOTS_DASHBOARD, "/tracking/lc"),
  },
  activities: {
    root: path(ROOTS_DASHBOARD, "/activities"),
    list: path(ROOTS_DASHBOARD, "/activities/list"),
    checkins: path(ROOTS_DASHBOARD, "/activities/checkins"),
  },

  finance: {
    root: path(ROOTS_DASHBOARD, "/finance"),
    pacebilling: path(ROOTS_DASHBOARD, "/finance/pace-billing"),
    // billing: path(ROOTS_DASHBOARD, "/finance/billing"),
    // transactions: path(ROOTS_DASHBOARD, "/finance/transactions"),
  },
};
